module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sky-gallery"
  }, [_c('ul', {
    staticClass: "gallery"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.openLightbox(index)
        }
      }
    }, [_c('sky-crop', {
      attrs: {
        "src": item.src,
        "mode": "cover",
        "container": "item"
      }
    })], 1)
  })), _vm._v(" "), (_vm.lightbox) ? [_c('sky-lightbox', {
    attrs: {
      "type": "images",
      "name": _vm.lightbox,
      "items": _vm.items
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/vue-loader/lib/template-compiler?{"id":"data-v-0f0c8a76"}!./scripts/sky-gallery/sky-gallery.html
// module id = 340
// module chunks = 1